var map = {
	"./category-icons/fish.png": "49a1",
	"./fiskerikajen/fish.png": "fe2a",
	"./fiskidag/fish.png": "bd41",
	"./fsg/fish.png": "be95",
	"./kvalitetsfisk/fish.png": "eda5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef83";